import './ClarifyModal.scss';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../../../design/buttons/ButtonWithLoader';
import { S_Modal } from '../../../../../../design/modals/modal/S_Modal';
import { TextAreaWithAutocomplete } from '../../../../../components/TextAreaWithAutocomplete';

interface IProps {
  showModal: boolean;
  question: string;
  onToggleChange: () => void;
  onQuestionChange: (value: string) => void;
  onSaveClarification: () => Promise<void>;
}

export const RequestClarificationModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Modal
      className='image-clarifications-modal'
      isOpen={props.showModal}
      toggle={props.onToggleChange}
      headerText={t('clarifications.request_modal.header')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onToggleChange}
          >
            {t('cancel')}
          </Button>
          <ButtonWithLoader
            loaderKey='request-clarification-button'
            id='add-clarification'
            onClick={props.onSaveClarification}
            disabled={!props.question}
          >
            {t('clarifications.request_modal.save')}
          </ButtonWithLoader>
        </>
      }
    >
      <div>{t('clarifications.request_modal.caption')}:</div>
      <TextAreaWithAutocomplete
        maxLength={210}
        value={props.question}
        onChange={props.onQuestionChange}
        autocompleteOptions={[]}
        autofocus
        counter
      />
    </S_Modal>
  );
});
